import React from 'react';
import './Tiles.scss';
import { TileGroupProps } from './types';

export const TileGroup = <T,>(props: TileGroupProps<T>): JSX.Element => {
    const { tiles } = props;

    return (
        <div className="tile-group">
            {tiles.map((tile) => props.children(tile))}
        </div>
    );
};
